export default __webpack_public_path__ + "static/media/showcase-poster.a7a5db12.png";